import React from "react"
import styled from "styled-components"

const Embed = styled.div`  
  border:5px solid rgba(72, 75, 88, 0.5);
  border-radius:5px;
`


const Map = () => {
  return (
    <Embed className="embed-responsive embed-responsive-16by9">
      <iframe
        className="embed-responsive-item"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d183.65859887125492!2d-113.73562109304935!3d42.565110901343424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87cc43673717937f%3A0xaf4dd7030f24ac30!2sEngineered%20Metal%20Buildings!5e0!3m2!1sen!2sus!4v1761205647389!5m2!1sen!2sus"
        allowFullScreen=""
        loading="lazy"
        title="map"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Embed>
  )
}

export default Map